export default __webpack_public_path__ + "static/media/Logo-vero-01.5ec49990.jpg";